const state = {
  unreadCount: 0
}

export default state
